import React from 'react';
import styled from 'styled-components';

import useStore from '~/store';
import Sharing from '~/components/Sharing';
import IWLogo from '~/assets/iw-logo.svg';

const FooterWrapper = styled.div`
  margin-top: 10px;
  display: flex;
  justify-content: space-between;
  align-items: center;
`;

const FooterLeftWrapper = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  width: 100%;
`;

const AdditionalLink = styled.div`
  font-size: 12px;
  color: black;
  text-align: right;

  a,
  span {
    color: black;
    text-decoration: underline;
    cursor: pointer;
  }
`;

const selector = (state) => state.setInfoboxContent;

function Footer() {
  const setInfoboxContent = useStore(selector);

  return (
    <FooterWrapper>
      <FooterLeftWrapper>
        <a rel="noopener noreferrer" target="_blank" href={config.logoLink}>
          <IWLogo width={42} height={26} />
        </a>
        <Sharing setInfoboxContent={setInfoboxContent} />
      </FooterLeftWrapper>

      <div style={{ maxWidth: 400 }}>
        <AdditionalLink>
          Zur{' '}
          <a rel="noopener noreferrer" target="_blank" href={config.studyLink}>
            Studie
          </a>
        </AdditionalLink>
        <AdditionalLink>
          Definitionen und Hintergrundinformationen unter{' '}
          <span onClick={() => setInfoboxContent('faq')}>Info</span>
        </AdditionalLink>
      </div>
    </FooterWrapper>
  );
}

export default Footer;
